module.exports = __webpack_public_path__ + "img/2.8d963f4f.jpg";